import SecureStoreWeb from './SecureStoreWeb'
import { getPlatform } from './platformUtils'

export interface BiometricsUserData {
    username: string // login
    password: string // login
    biometricsActive: boolean
    avatar: string
    email: string
    user_name: string
    isVisible: boolean
}

const STORAGE_KEY = 'biometrics'

export class LoginBiometricsStorage {
    static async addDataBiometricsUser(data: BiometricsUserData): Promise<void> {
        try {
            const dataUsers = await this.getAllDataBiometrics()
            // No almacenar contraseñas en claro en web
            const safeData = {
                ...data,
                password: getPlatform().OS === 'web' ? '' : data.password,
            }
            const newDataUsers = [...dataUsers, safeData]
            const newUsers = JSON.stringify(newDataUsers)
            await SecureStoreWeb.setItemAsync(STORAGE_KEY, newUsers)
        } catch (error) {
            throw new Error(`Error setting biometrics: ${error}`)
        }
    }

    static async getAllDataBiometrics(filtered = true): Promise<BiometricsUserData[]> {
        try {
            const dataUsersStorage = await SecureStoreWeb.getItemAsync(STORAGE_KEY)

            if (!dataUsersStorage) {
                await SecureStoreWeb.setItemAsync(STORAGE_KEY, JSON.stringify([]))
                return []
            }
            let dataUsersStorageParsed = JSON.parse(dataUsersStorage)

            if (filtered && dataUsersStorageParsed && dataUsersStorageParsed.length > 0) {
                dataUsersStorageParsed = dataUsersStorageParsed.filter((data: BiometricsUserData) => data.isVisible == true)
            }

            return dataUsersStorageParsed
        } catch (error) {
            console.error(' getAllDataBiometrics ~ error:', error)

            return []
        }
    }

    static async removeDataBiometricsUser(username: string): Promise<void> {
        try {
            const dataUsers = await this.getAllDataBiometrics()

            const newDataUsers = dataUsers.filter((data: BiometricsUserData) => data.username !== username)

            await SecureStoreWeb.setItemAsync(STORAGE_KEY, JSON.stringify(newDataUsers))
        } catch (error) {
            throw new Error(`Error removing biometrics: ${error}`)
        }
    }

    static async removeAllDataBiometricsUser(): Promise<void> {
        try {
            await SecureStoreWeb.deleteItemAsync(STORAGE_KEY)
        } catch (error) {
            throw new Error(`Error removing biometrics: ${error}`)
        }
    }

    static async registerUserExists(username: string): Promise<boolean> {
        try {
            const dataUsers = await this.getAllDataBiometrics()
            const user = dataUsers.find((data: BiometricsUserData) => data.username === username)
            return !!user
        } catch (error) {
            throw new Error(`Error checking if user exists: ${error}`)
        }
    }

    static async updateDataBiometricsUser(username: string, data: BiometricsUserData): Promise<void> {
        try {
            const dataUsers = await this.getAllDataBiometrics(false)
            if (dataUsers) {
                const dataUsersUpdated = dataUsers.map((user: BiometricsUserData) => {
                    if (user.username === username) {
                        return {
                            ...user,
                            ...data,
                            // No persistir contraseñas en web
                            password: getPlatform().OS === 'web' ? '' : data.password,
                        }
                    }
                    return user
                })
                await SecureStoreWeb.setItemAsync(STORAGE_KEY, JSON.stringify(dataUsersUpdated))
            }
        } catch (error) {
            console.error('updateDataBiometricsUser error:', error)
            //throw new Error(`Error updating biometrics: ${error}`)
        }
    }

    static async getDataBiometricsUserByUsername(username: string): Promise<BiometricsUserData> {
        try {
            const dataUsers = await this.getAllDataBiometrics()
            return dataUsers.find((data: BiometricsUserData) => data.username === username)
        } catch (error) {
            throw new Error(`Error getting biometrics: ${error}`)
        }
    }
}
